var React = require('react');

function Deezer (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M115.35 20.7H90.52v14.49h24.83V20.7zM115.35.52H90.52v14.49h24.83V.52zM115.35 40.87H90.52v14.49h24.83V40.87zM25.34 61.05H.51v14.49h24.83V61.05zM55.34 61.05H30.51v14.49h24.83V61.05zM85.35 61.05H60.52v14.49h24.83V61.05zM115.35 61.05H90.52v14.49h24.83V61.05zM85.35 40.87H60.52v14.49h24.83V40.87zM55.34 40.87H30.51v14.49h24.83V40.87zM55.34 20.7H30.51v14.49h24.83V20.7z"}));
}

Deezer.defaultProps = {"width":"116","height":"76","viewBox":"0 0 116 76"};

module.exports = Deezer;

Deezer.default = Deezer;
